import axios from './axios';

export default {
  fetchMe() {
    return axios.get('/student/me');
  },
  updateAvatar(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post('/student/avatar', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  update(params) {
    return axios.put('/student', params);
  },
  deleteAvatar() {
    return axios.delete('/student/delete_avatar');
  },
};
